import React from 'react';
import { AREA_BOUNDS } from '../../utils/estimator';

export default function StepArea({ isUA, area, onChange }) {
  return (
    <div className="py-10 border-b border-border/60">
      <div className="flex items-baseline justify-between mb-4 gap-4">
        <span className="text-xs uppercase tracking-widest text-muted-foreground">
          {isUA ? 'Площа' : 'Area'}
        </span>
        <span className="text-sm tabular-nums text-foreground">
          {area} {isUA ? 'м\u00B2' : 'm\u00B2'}
        </span>
      </div>
      <input
        type="range"
        min={AREA_BOUNDS.min}
        max={AREA_BOUNDS.max}
        step={1}
        value={area}
        onChange={(e) => onChange(Number(e.target.value))}
        className="estimator-slider w-full"
        data-testid="cfg-area"
      />
      <div className="flex justify-between text-[10px] text-muted-foreground/50 mt-1.5">
        <span>{AREA_BOUNDS.min}</span>
        <span>{AREA_BOUNDS.max}</span>
      </div>
    </div>
  );
}
